import { Box, Button, Typography } from '@mui/material'
import FAIcon from 'Theme/FAIcon'
import { FA_ICONS } from 'Theme/font-awesome-icon-constants'

export const ArchiveInfoCard = ({
  eventTypeName,
  navigateTo,
}) => (
  <Box
    sx={(theme) => ({
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      borderRadius: theme.spacing(2),
      background: 'linear-gradient(315deg, rgba(32, 33, 38, 0.42) 0%, #1F2126 100%)',
      padding: theme.spacing(3),
      marginBottom: '40px',
    })}
  >
    <Box
      gap={3}
      display="flex"
      alignItems="center"
    >
      <FAIcon
        iconClassName={FA_ICONS.BOX_ARCHIVE_LIGHT}
        iconFontSize={46}
        color="#B6EFFF"
      />
      <Box
        display="flex"
        flexDirection="column"
        gap="12px"
      >
        <Typography
          variant="h3"
          sx={{ textTransform: 'capitalize' }}
        >
          deleted {eventTypeName}
        </Typography>
        <Typography
          variant="body2"
          color="text.tertiary"
        >
          This page visible only for you and serves as an archive for all deleted {eventTypeName}
        </Typography>
        <Box
          display="flex"
          alignItems="center"
          gap={1}
        >
          <FAIcon
            iconClassName={FA_ICONS.INFO}
            iconFontSize={16}
            color="text.tertiary"
          />
          <Typography
            variant="body2"
            color="text.tertiary"
          >
            Terminated {eventTypeName} are securely stored for 3 months
          </Typography>
        </Box>
      </Box>
    </Box>
    <Button
      color="inherit"
      startIcon={
        <FAIcon
          iconClassName={FA_ICONS.ARROW_LEFT}
          color="text.tertiary"
        />
      }
      onClick={navigateTo}
    >
      Back to {eventTypeName}
    </Button>
  </Box>
)
